"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MobileControlPanel = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const React = require("react");
const _1 = require("./");
const MosaicIcon_1 = require("../../../../Shared/Components/MosaicIcon");
const MobileControlPanel = ({ dictionary: { searchInputAriaLabel, filterBtnLabel, resetFilterLabel }, selectedFiltersCount, filters, showMobileFilter, onSearchFilterChange, }) => {
    const columnNameForSearch = 'name';
    const [isSearchApplied, setIsSearchApplied] = React.useState(false);
    const [searchValue, setSearchValue] = React.useState('');
    const [lastSearchedValue, setLastSearchedValue] = React.useState('');
    const shouldHaveFiltersButton = React.useCallback(() => {
        for (const key in filters) {
            if (filters[key].items.length > 1) {
                return true;
            }
        }
        return false;
    }, [filters]);
    const onInputChange = (event) => {
        setSearchValue(event.target.value);
    };
    const resetSearchFilter = () => {
        onSearchFilterChange(columnNameForSearch, '');
        setIsSearchApplied(false);
        setSearchValue('');
        setLastSearchedValue('');
    };
    const makeSearchFilter = () => {
        setIsSearchApplied(true);
        onSearchFilterChange(columnNameForSearch, searchValue);
        setLastSearchedValue(searchValue);
    };
    const onSearchButtonClick = () => {
        if (searchValue !== lastSearchedValue) {
            makeSearchFilter();
        }
        else if (isSearchApplied && searchValue === lastSearchedValue) {
            resetSearchFilter();
        }
    };
    const onInputKeyDown = (event) => {
        if (event.key === 'Enter') {
            if (isSearchApplied && searchValue === '') {
                resetSearchFilter();
            }
            else if (searchValue !== lastSearchedValue) {
                makeSearchFilter();
            }
        }
    };
    return ((0, jsx_runtime_1.jsxs)("div", { className: "table-controls gap-2xs flex w-full justify-around sm:hidden", children: [(0, jsx_runtime_1.jsxs)("div", { className: "table-controls__search table-mobile-search form-input-container sm addon-start w-full", children: [(0, jsx_runtime_1.jsxs)("button", { type: "button", onClick: onSearchButtonClick, className: "table-mobile-search__btn", "aria-label": isSearchApplied ? resetFilterLabel : searchInputAriaLabel, children: [(0, jsx_runtime_1.jsx)(MosaicIcon_1.MosaicIcon, { name: "search-outline", className: "icon-md addon-content" }), isSearchApplied ? ((0, jsx_runtime_1.jsx)(MosaicIcon_1.MosaicIcon, { name: "cancel-outline", className: "icon-md addon-content left-auto! right-[5px]!" })) : null] }), (0, jsx_runtime_1.jsx)("input", { className: "table-mobile-search__input form-input pr-2xs h-[44px] ", type: "text", placeholder: searchInputAriaLabel, "aria-label": searchInputAriaLabel, onChange: onInputChange, onKeyDown: onInputKeyDown, value: searchValue })] }), shouldHaveFiltersButton() && ((0, jsx_runtime_1.jsx)(_1.FiltersButton, { buttonLabel: filterBtnLabel, selectedFiltersCount: selectedFiltersCount, showMobileFilter: showMobileFilter }))] }));
};
exports.MobileControlPanel = MobileControlPanel;
